import { ref, watch, onUnmounted, onMounted } from 'vue'

import { createRequest, createRequestWithFormData } from '@/helpers/utilities'

export const useModuleId = (callback, event_name = 'crud_change_id') => {
  // Module Current ID Logic
  const moduleId = ref(0)
  const updatecurrentId = (e) => {
    if (event_name == 'custom_form') {
      moduleId.value = e.detail.form_id
    } else {
      moduleId.value = Number(e.detail.form_id)
    }
    callback()
  }

  document.addEventListener(event_name, updatecurrentId)

  onUnmounted(() => window.removeEventListener(event_name, updatecurrentId))

  return moduleId
}

export const useFormModuleId = (callback, event_name = 'crud_change_id') => {
  const appointmentType = ref('')
  const appointmentId = ref(null)
  const formId = ref(null)

  const updatecurrentId = (e) => {
    appointmentType.value = e.detail.appointment_type || ''
    appointmentId.value = e.detail.appointment_id || null
    formId.value = e.detail.form_id || null

    callback()
  }

  document.addEventListener(event_name, updatecurrentId)
  onUnmounted(() => document.removeEventListener(event_name, updatecurrentId))

  return {
    appointmentType,
    appointmentId,
    formId
  }
}

export const formatValue = (value) => {
  switch (value) {
    case null:
      return ''
    case true:
      return 1
    case false:
      return 0
    default:
      return value
  }
}

const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB

export const checkFileSizes = (body) => {
  for (const key of Object.keys(body)) {
    const val = body[key]
    if (val instanceof File && val.size > MAX_FILE_SIZE) {
      Swal.fire({
        icon: 'error',
        title: 'Fichier trop volumineux',
        text: `Le fichier "${val.name}" dépasse la taille maximale autorisée de 10 Mo.`,
      })
      return false
    }
  }
  return true
}

export const useRequest = () => {
  const getRequest = async ({ url, id }) => {
    return createRequest(url(id))
  }

  // {
  //   method: 'GET',
  //   path: url,
  // };
  const listingRequest = async ({ url, data = {} }) => {
    return createRequest(url(data))
  }

  // {
  //   method: 'POST',
  //   path: url,
  // };
  const storeRequest = async ({ url, body, type }) => {
    if (type == 'file') {
      if (!checkFileSizes(body)) return Promise.reject({ cancelled: true })
      let formData = new FormData()
      Object.keys(body).map((fieldName) => {
        formData.append(fieldName, formatValue(body[fieldName]))
      })
      return createRequestWithFormData(url(), { Accept: 'application/json' }, formData)
    }
    return createRequest(url(), {}, body)
  }

  // {
  //   method: 'PUT|PATCH',
  //   path: url,
  // };
  const updateRequest = async ({ url, id, body, type }) => {
    if (type !== undefined && type == 'file') {
      if (!checkFileSizes(body)) return Promise.reject({ cancelled: true })
      let formData = new FormData()
      Object.keys(body).map((fieldName) => {
        formData.append(fieldName, formatValue(body[fieldName]))
      })
      formData.append('_method', 'PUT')
      return createRequestWithFormData(url(id), { Accept: 'application/json' }, formData)
    } else {
      return createRequest(url(id), {}, body)
    }
  }

  // {
  //   method: 'DELETE',
  //   path: url,
  // };
  const deleteRequest = async ({ url, id }) => {
    return createRequest(url(id))
  }

  return {
    listingRequest,
    getRequest,
    storeRequest,
    updateRequest,
    deleteRequest
  }
}

export const useOnOffcanvasHide = (elemName, callback) => {
  onMounted(() => {
    const formOffcanvas = document.getElementById(elemName)
    formOffcanvas.addEventListener('hidden.bs.offcanvas', function (value) {
      if (typeof callback === 'function') {
        callback()
      }
    })
  })
}

export const useOnOffcanvasShow = (elemName, callback) => {
  onMounted(() => {
    const formOffcanvas = document.getElementById(elemName)
    formOffcanvas.addEventListener('shown.bs.offcanvas', function (value) {
      if (typeof callback === 'function') {
        callback()
      }
    })
  })
}

export const useOnModalHide = (elemName, callback) => {
  console.log('open')
  onMounted(() => {
    const modal = document.getElementById(elemName)
    modal.addEventListener('hide.bs.modal', function (value) {
      if (typeof callback === 'function') {
        callback()
      }
    })
  })
}
